// extracted by mini-css-extract-plugin
export default {"wrapper":"StarBar_wrapper__d8h42"};